<template>
  <div id="vrTestResultHistory">
    <div>
      <h5 class="mb-3">VR空間ナビ測定履歴</h5>
      <p v-if="vrTestResults.length < 1">
        測定履歴はありません。
      </p>
      <b-table v-else hover responsive
        :items="vrTestResults"
        :fields="fields"
        @row-clicked="myRowClickHandler"
      ></b-table>
    </div>
  </div>
</template>

<script>
  import moment from "moment-timezone";
  import {GET_VR_TEST_RESULT_HISTORY} from "@/store/actions.type";
  export default {
    name: 'vrTestResultHistory',
    data() {
      return {
        fields: [
          {
            key: "index_num",
            label: "回数"
          },
          {
            key: "created_at",
            label: "日付"
          },
          {
            key: "brain_function_status",
            label: "判定"
          }
        ],
        isloading: false,
        vrTestResults: []
      }
    },
    methods: {
      getVrTestHistoryFromApi() {
        this.isLoading = this.$loading.show({ loader: "dots", color: "#007bff" });
        this.params = this.$route.params;
        this.$store.dispatch(GET_VR_TEST_RESULT_HISTORY, {
          patientId: this.params.patientId
        })
        .then(response => {
          this.isLoading.hide();
          this.vrTestResults = response.data;
          this.vrTestResults.forEach(result =>
            result.created_at = moment.utc(result.created_at).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm")
          );
        })
      },
      myRowClickHandler(record, index) {
        this.$router.push({
          name: "VrTestResultDetails",
          params: {
            patientId: this.params.patientId,
            vrTestResultId: record.id
          },
          query: {index: record.index_num}
        });
      }
    },
    created() {
      this.getVrTestHistoryFromApi()
    },
  }
</script>
